import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../../../../../Shared/Stores/FluxResponse";
import {
    IInvestmentTableData,
    IModelInvestment,
    InvestmentsStatic,
    ModelUnderlyingInvestmentsStatic,
} from "./InvestmentsStatic";

export const InvestmentsDispatcher: Dispatcher<FluxResponse<IInvestmentTableData>> = new Dispatcher<
    FluxResponse<IInvestmentTableData>
>();
export const InvestmentsStore: InvestmentsStatic = new InvestmentsStatic();

export const ModelUnderlyingInvestmentsDispatcher: Dispatcher<FluxResponse<IModelInvestment>> = new Dispatcher<
    FluxResponse<IModelInvestment>
>();
export const ModelUnderlyingInvestmentsStore: ModelUnderlyingInvestmentsStatic = new ModelUnderlyingInvestmentsStatic();
